/**
 * 会员管理 Saga集合
 */
import structure from './structure/model';
import employee from './employee/model';
import menuconfig from './menuconfig/model';
import assignauthority from './assignauthority/model';

export default [
    ...Object.values(structure.sagas), // 架构管理
    ...Object.values(employee.sagas), // 员工管理
    ...Object.values(menuconfig.sagas), // 菜单管理
    ...Object.values(assignauthority.sagas), // 权限分配
];
